import React from "react";
import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { EffectFade, Navigation, Autoplay } from "swiper/modules";
import one from "../images/one.jpg";
import two from "../images/two.jpg";
import three from "../images/three.jpg";
import four from "../images/four.jpg";
import five from "../images/five.jpg";

const fireworkImages = [one, two, three, four, five];

const HomePage = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // ✅ Stack on small screens, row on desktop
            maxWidth: "90vw",
            width: "100%",
          }}
        >
          {/* Left - Slideshow */}
          <Box
            sx={{
              flex: 3,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              height: { xs: "50vh", md: "80vh" }, // ✅ Adjust height for mobile
            }}
          >
            <Swiper
              modules={[EffectFade, Navigation, Autoplay]}
              effect="fade"
              navigation
              autoplay={{ delay: 3000 }}
              loop
              style={{ width: "100%", height: "100%" }}
            >
              {fireworkImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img}
                    alt={`Firework ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>

          {/* Right - Text Section */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#111",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
              textAlign: "center",
              marginLeft: { xs: "0", md: "1rem" }, // ✅ Remove margin on mobile
              marginTop: { xs: "1rem", md: "0" }, // ✅ Add spacing between stacked elements
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: "bold" }}
            >
              Welcome to Sonic Blast Fireworks
            </Typography>
            <Typography
              sx={{ marginTop: "10px", fontSize: "18px", padding: ".4rem" }}
            >
              Experience the most breathtaking fireworks display in the galaxy!
              High-quality pyrotechnics for events, celebrations, and more.
              <br />
              <br />
              <strong>Pre-Orders Availability:</strong> <br />
              🎆 **July 4th:** Jan 1 - Apr 30 <br />
              🎇 **New Year's:** Jul 5 - Oct 31 <br />
              <br />
              <strong>💲 $500 Minimum Purchase</strong>
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Contact Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1rem",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            padding: "10px",
            color: "black",
            fontSize: { xs: "14px", md: "18px" }, // ✅ Adjust font size on mobile
          }}
        >
          📞 Contact us at: <br />
          <strong>(832) 814-8332</strong> <br />
          ✉ sonic.fireworks@yahoo.com
        </Typography>
      </Box>
    </>
  );
};

export default HomePage;
